module.exports = __webpack_public_path__ + "static/coloicon-e0692a167c971723764560ae91894c40.jpeg";